export default class EnderecoModel {
  constructor({
    id = 0,
    cep = '',
    estado = '',
    cidade = '',
    bairro = '',
    rua = '',
    numero = '',
    complemento = null,
    pontoDeReferecia = null,
  } = {}) {
    this.id = id
    this.cep = cep
    this.estado = estado
    this.cidade = cidade
    this.bairro = bairro
    this.rua = rua
    this.numero = numero
    this.complemento = complemento
    this.pontoDeReferecia = pontoDeReferecia
  }
}
